import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private toastr: ToastrService) { }

  // enableHtml renders the message and title as HTML, so escape them; newlines become <br>.
  private escapeHtml(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/\r?\n/g, '<br>');
  }

  private formatMessage(message: any): string {
    return '<div class="toastr-message">' + this.escapeHtml(message) + '</div>';
  }

  showSuccess(message: any, title: any){
    // Return toast reference to allow chaining via onHidden
    return this.toastr.success(this.formatMessage(message), this.escapeHtml(title), {enableHtml: true, progressBar: true});
}

showError(message: any, title: any){
    this.toastr.error(this.formatMessage(message), this.escapeHtml(title), {enableHtml: true, progressBar: true});
}

showInfo(message: any, title: any){
    this.toastr.info(this.formatMessage(message), this.escapeHtml(title), {enableHtml: true, progressBar: true});
}

showWarning(message: any, title: any){
    this.toastr.warning(this.formatMessage(message), this.escapeHtml(title), {enableHtml: true, progressBar: true});
}
}
